export default "__VITE_ASSET__MKM5hc7y__"